import {App} from '../App';
import {About, Gallery} from '../components';

export const routes = [
  {
    path: '/',
    component: App,

    childRoutes: [
      {
        path: 'about',
        component: About,
      },
      {
        path: 'gallery/:image',
        component: Gallery,
      },
    ]
  },

  {
    path: '*',
    component: App,
  },
];




// WEBPACK FOOTER //
// ./src/router/routes.js